import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios, { cookies } from "../../axios/axios";

const VideoEditingEditorDetail = () => {
  const [videoEditing, setVideoEditing] = useState({});
  const [status, setStatus] = useState(1);
  const [selectedEditor, setSelectedEditor] = useState("");
  const [fileLocation, setFileLocation] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [message, setMessage] = useState("");

  const { id } = useParams();
  const navigate = useNavigate();

  const user = cookies.get("user");
  const userRole = user?.user?.role;
  const userName = user?.user?.fname;

  const getVideoEditingById = async () => {
    try {
      const response = await axios.get(`/video-editing/${id}`);
      setVideoEditing(response.data);
      setSelectedEditor(response.data.editor || "");
      setFileLocation(response.data.fileLocation || "");
      setStatus(response.data.status || 1);
    } catch (error) {
      seterrorMessage(error.response?.data?.message || "An error occurred");
    }
  };

  useEffect(() => {
    getVideoEditingById();
  }, []);

  const updatevideoEditing = async () => {
    try {
      await axios.put(`/video-editing/${id}`, {
        status,
        editor: userRole === "editor" ? userName : selectedEditor,
        fileLocation,
        message,
      });
      navigate("/videoediting-editor");
    } catch (error) {
      seterrorMessage("Failed to update order");
    }
  };

  return (
    <div className="container mt-4">
      {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
      <div className="row">
        {/* Left Panel */}
        <div className="col-md-6">
          <div className="card mb-3">
            <div className="card-header fw-600">Job Details</div>
            <div className="card-body">
              <p>
                <strong>Event Name:</strong> {videoEditing?.order_name}
              </p>
              <p>
                <strong>Service Type:</strong>{" "}
                {videoEditing?.serviceId?.service}
              </p>
              <p>
                <strong>Album Type:</strong> {videoEditing?.order_name}
              </p>
            </div>
          </div>{" "}
          <div className="card mb-3">
            <div className="card-header fw-600">Order Details</div>
            <div className="card-body">
              <p>
                <strong>Video Package :</strong> {videoEditing?.video_package}
              </p>
              <p>
                <strong>Raw Footage :</strong> {videoEditing?.raw_footage}
              </p>{" "}
              <p>
                <strong>Output Video :</strong> {videoEditing?.output_video}
              </p>{" "}
              <p>
                <strong>Color Correction :</strong>{" "}
                {videoEditing?.color_correction}
              </p>{" "}
              <p>
                <strong>Music :</strong> {videoEditing?.music}
              </p>{" "}
              <p>
                <strong> Text Overlay / Title Slide :</strong>{" "}
                {videoEditing?.text_overlay}
              </p>{" "}
              <p>
                <strong>Quantity :</strong> {videoEditing?.quantity}
              </p>{" "}
              <p>
                <strong> Upload:</strong> {videoEditing?.images}
              </p>{" "}
              <p>
                <strong>Aditional notes :</strong>{" "}
                {videoEditing?.additional_notes}
              </p>
            </div>
          </div>
        </div>

        {/* Right Panel */}
        <div className="col-md-6">
          <div className="card mb-3">
            <div className="card-header fw-600">Order Operations</div>
            <div className="card-body">
              <p>
                <strong>Client ID:</strong> {user.user.id}
              </p>
              <p>
                <strong>Order ID:</strong> {videoEditing.id}
              </p>
              <p>
                <strong>User Feedback:</strong> {videoEditing.sampleFeedback}
              </p>
              <p>
                <strong>Sample Status:</strong>{" "}
                {videoEditing.sampleStatus === "approved" ? (
                  <span className="btn rounded-0 btn-success btn-sm p-2 ms-2">
                    Approved
                  </span>
                ) : videoEditing.sampleStatus === "declined" ? (
                  <span className="btn rounded-0 btn-danger btn-sm p-2 ms-2">
                    Declined
                  </span>
                ) : (
                  <span className="text-muted ms-2">Not Selected</span>
                )}
              </p>
              <p>
                <strong>Order Place Date:</strong>{" "}
                {new Date(videoEditing?.createdAt).toLocaleDateString()}
              </p>
              <div>
                <label className="form-label">Order Status</label>
                <select
                  className="form-select"
                  value={status}
                  onChange={(e) => setStatus(Number(e.target.value))}
                >
                  <option value={1}>New Order</option>
                  <option value={2}>In Process</option>
                  <option value={3}>On Hold</option>
                  <option value={4}>In QC</option>
                  <option value={5}>Sample Sent</option>
                  <option value={6}>In Revision</option>
                  <option value={7}>Cancelled</option>
                  <option value={8}>Completed</option>
                </select>{" "}
              </div>

              <div className="mt-3">
                <label className="form-label mt-3">Editor</label>
                <input
                  type="text"
                  className="form-control"
                  value={userName}
                  readOnly
                />
              </div>

              <label className="form-label mt-3">File Location</label>
              <input
                type="text"
                className="form-control"
                value={fileLocation}
                onChange={(e) => setFileLocation(e.target.value)}
              />

              <button
                onClick={updatevideoEditing}
                className="btn text-light bg_maincolor mt-3"
              >
                Update 
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoEditingEditorDetail;
